(() => {
  // prevent double-loading
  if (window.__nbCartExpectedDeliveryLoaded) return;
  window.__nbCartExpectedDeliveryLoaded = true;

  const SELECTOR = '[data-cart-expected-delivery]';
  const TZ = 'Europe/Sofia';
  const CUT_OFF_HOUR = 12;

  const CONFIG_URL = 'https://admin.feelyou.bg/delivery-promise/theme-config?store_key=target_1';
  const DEFAULT_CONFIG = {
    mode: 'PROFILE_TAGS',
    is_active: true,
    profiles: {
      EXPRESS: { min: 1, max: 2 },
      STANDARD: { min: 2, max: 4 },
      RO_FAST: { min: 3, max: 6 },
      GROUP_5_8: { min: 5, max: 8 },
      BTS: { min: 10, max: 14 }
    },
    transit: {}
  };
  let remoteConfigPromise = null;
  const SNAPSHOT_VERSION = 'cart_expected_delivery_v1';
  const pad2 = (n) => String(n).padStart(2, '0');
  const fmtDM = (d) => `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}`;

  const fmtISODate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  function nowInTZ(tz) {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
    } catch (e) {
      return new Date();
    }
  }

  function orthodoxEasterSunday(y) {
    const a = y % 4, b = y % 7, c = y % 19;
    const d = (19 * c + 15) % 30;
    const e = (2 * a + 4 * b - d + 34) % 7;
    const m = Math.floor((d + e + 114) / 31);
    const day = ((d + e + 114) % 31) + 1;
    const dt = new Date(y, m - 1, day);
    dt.setDate(dt.getDate() + 13);
    return dt;
  }

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  function isWeekend(d) { return d.getDay() === 0 || d.getDay() === 6; }

  function fixedBgHolidays(y) {
    const fixed = [
      new Date(y, 0, 1), new Date(y, 2, 3),
      new Date(y, 4, 1), new Date(y, 4, 6), new Date(y, 4, 24),
      new Date(y, 8, 6), new Date(y, 8, 22),
      new Date(y, 11, 24), new Date(y, 11, 25), new Date(y, 11, 26)
    ];

    // one-off non-working days (BG)
    if (y === 2025) fixed.push(new Date(2025, 11, 31)); // 31.12.2025
    if (y === 2026) fixed.push(new Date(2026, 0, 2));   // 02.01.2026

    return fixed;
  }

  function easterBgHolidays(y) {
    const easter = orthodoxEasterSunday(y);
    const gf = new Date(easter); gf.setDate(gf.getDate() - 2);
    const gs = new Date(easter); gs.setDate(gs.getDate() - 1);
    const em = new Date(easter); em.setDate(em.getDate() + 1);
    return [gf, gs, easter, em];
  }

  function observedFixedBgHolidays(y) {
    const fixed = fixedBgHolidays(y);
    const observed = [];

    fixed.forEach((h) => {
      if (isWeekend(h)) {
        const obs = new Date(h);
        do {
          obs.setDate(obs.getDate() + 1);
        } while (
          isWeekend(obs)
          || fixed.some((x) => sameDay(x, obs))
          || observed.some((x) => sameDay(x, obs))
        );

        if (!observed.some((x) => sameDay(x, obs))) observed.push(obs);
      }
    });

    return observed;
  }

  function bgHolidays(y) {
    return fixedBgHolidays(y)
      .concat(easterBgHolidays(y))
      .concat(observedFixedBgHolidays(y));
  }

  function makeCalendar(now) {
    const y = now.getFullYear();
    const hol = bgHolidays(y).concat(bgHolidays(y + 1));

    function isHoliday(d) {
      for (let i = 0; i < hol.length; i++) {
        if (sameDay(hol[i], d)) return true;
      }
      return false;
    }

    function isBusiness(d) { return !isWeekend(d) && !isHoliday(d); }

    function nextBusinessDay(d) {
      const x = new Date(d);
      while (!isBusiness(x)) x.setDate(x.getDate() + 1);
      return x;
    }

    function addBusinessDaysFrom(base, days) {
      let d = new Date(base);
      d.setDate(d.getDate() + 1);
      let added = 0;

      while (added < days) {
        if (isBusiness(d)) added++;
        if (added < days) d.setDate(d.getDate() + 1);
      }

      while (!isBusiness(d)) d.setDate(d.getDate() + 1);
      return d;
    }

    return { isBusiness, nextBusinessDay, addBusinessDaysFrom };
  }

  function toIntOr(val, fallback) {
    const n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }
  let lastSnapshotSig = '';
  let snapshotTimer = null;

  function persistCartSnapshot(snapshot) {
    if (!snapshot || !window.fetch) return;
    const sig = [
      snapshot.range,
      snapshot.minDate,
      snapshot.maxDate,
      snapshot.profile,
      snapshot.country
    ].join('|');
    if (!sig || sig === lastSnapshotSig) return;
    lastSnapshotSig = sig;
    try {
      if (window.sessionStorage && window.sessionStorage.getItem('nb_delivery_promise_sig') === sig) return;
    } catch (e) {}
    if (snapshotTimer) clearTimeout(snapshotTimer);
    snapshotTimer = setTimeout(() => {
      snapshotTimer = null;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            nb_delivery_promise_range: snapshot.range,
            nb_delivery_promise_min_date: snapshot.minDate,
            nb_delivery_promise_max_date: snapshot.maxDate,
            nb_delivery_promise_profile: snapshot.profile,
            nb_delivery_promise_country: snapshot.country,
            nb_delivery_promise_calculated_at: snapshot.calculatedAt,
            nb_delivery_promise_version: SNAPSHOT_VERSION
          }
        })
      })
        .then((response) => {
          if (!response || !response.ok) return;
          try {
            if (window.sessionStorage) window.sessionStorage.setItem('nb_delivery_promise_sig', sig);
          } catch (e) {}
        })
        .catch(() => {});
    }, 120);
  }
  function mergeConfig(remote) {
    if (!remote || remote.ok === false || remote.is_active === false) return DEFAULT_CONFIG;
    return {
      mode: remote.mode || DEFAULT_CONFIG.mode,
      is_active: remote.is_active !== false,
      profiles: Object.assign({}, DEFAULT_CONFIG.profiles, remote.profiles || {}),
      transit: Object.assign({}, DEFAULT_CONFIG.transit, remote.transit || {})
    };
  }

  function loadConfig() {
    if (remoteConfigPromise) return remoteConfigPromise;
    if (!window.fetch) {
      remoteConfigPromise = Promise.resolve(DEFAULT_CONFIG);
      return remoteConfigPromise;
    }
    remoteConfigPromise = Promise.race([
      fetch(CONFIG_URL, { credentials: 'omit', cache: 'no-store' })
        .then((response) => response && response.ok ? response.json() : null)
        .then(mergeConfig)
        .catch(() => DEFAULT_CONFIG),
      new Promise((resolve) => setTimeout(() => resolve(DEFAULT_CONFIG), 1200))
    ]);
    return remoteConfigPromise;
  }

  function promiseDaysForProfile(profileKey, country, config, fallback) {
    const source = config || DEFAULT_CONFIG;
    const safeFallback = fallback || { min: 2, max: 4 };
    const profile = (source.profiles && (source.profiles[profileKey] || source.profiles.STANDARD)) || null;
    if (!profile) return safeFallback;
    let min = toIntOr(profile.min, safeFallback.min);
    let max = toIntOr(profile.max, safeFallback.max);
    if (String(source.mode || '').toUpperCase() === 'EU_PROFILE_COUNTRY') {
      const transit = (source.transit && (source.transit[country] || source.transit.DEFAULT)) || null;
      if (transit) {
        min += toIntOr(transit.min, 0);
        max += toIntOr(transit.max, 0);
      }
    }
    return { min, max };
  }



  async function computeAndFill(container) {
    if (!container) return;

    const betweenEl = container.querySelector('[data-role="between"]');
    const tlWrap = container.querySelector('[data-role="timeline"]');
    const leftEl = container.querySelector('[data-role="leftDate"]');
    const rightEl = container.querySelector('[data-role="rightDate"]');
    if (!betweenEl) return;

    const lang = (container.getAttribute('data-lang') || 'bg').toLowerCase();
    const isEN = lang.includes('en');

    let minDays = toIntOr(container.getAttribute('data-agg-min'), 2);


    let maxDays = toIntOr(container.getAttribute('data-agg-max'), 4);


    const profileKey = String(container.getAttribute('data-profile-key') || 'STANDARD').toUpperCase();


    const country = String(container.getAttribute('data-country') || 'BG').toUpperCase();


    const config = await loadConfig();


    const promiseDays = promiseDaysForProfile(profileKey, country, config, { min: minDays, max: maxDays });


    minDays = promiseDays.min;


    maxDays = promiseDays.max;

    const now = nowInTZ(TZ);
    const cal = makeCalendar(now);

    let base = new Date(now);
    if (now.getHours() >= CUT_OFF_HOUR) base.setDate(base.getDate() + 1);
    base = cal.isBusiness(base) ? base : cal.nextBusinessDay(base);

    const minDate = cal.addBusinessDaysFrom(base, minDays);
    const maxDate = cal.addBusinessDaysFrom(base, maxDays);

    const baseTxt = fmtDM(base);
    const startTxt = fmtDM(minDate);
    const endTxt = fmtDM(maxDate);

    const rangeTxt = (minDays === maxDays) ? startTxt : `${startTxt}–${endTxt}`;
    betweenEl.textContent =
      (minDays === maxDays)
        ? (isEN ? `Delivery on ${startTxt}` : `Доставка на ${startTxt}`)
        : (isEN ? `Delivery between ${startTxt}–${endTxt}` : `Доставка между ${startTxt}–${endTxt}`);    persistCartSnapshot({
      range: rangeTxt,
      minDate: fmtISODate(minDate),
      maxDate: fmtISODate(maxDate),
      profile: profileKey,
      country: String(container.getAttribute('data-country') || 'BG').toUpperCase(),
      calculatedAt: new Date().toISOString()
    });



    betweenEl.classList.remove('is-loading');

    if (tlWrap && leftEl && rightEl) {
      tlWrap.style.display = '';
      leftEl.textContent = baseTxt;
      rightEl.textContent = (minDays === maxDays) ? startTxt : `${startTxt}–${endTxt}`;
    }
  }

  let rafId = null;

  function initOnce() {
    const nodes = document.querySelectorAll(SELECTOR);
    if (!nodes || nodes.length === 0) return false;
    nodes.forEach(computeAndFill);
    return true;
  }

  function initAll(retryFrames = 10) {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      const ok = initOnce();
      if (!ok && retryFrames > 0) initAll(retryFrames - 1);
    });
  }

  window.NBExpectedDeliveryInit = initAll;

  initAll(10);
  document.addEventListener('dispatch:cart-expected-delivery:init', () => initAll(10));
})();